export default {
  computed: {
    staticBaseUrl () {
      return this.$getEnv.productionStaticPath
    }
  }
}
